// Global Instructions Rule Applied!
//
// Configuration → Deal Origination admin model: one row per 'Deal Type' lookup
// with whether it is excluded from the Deal Origination pipeline
// (cfg.pipeline_deal_type_exclusions) and how many deals of that type still
// hold a live origination pipeline row.
import { z } from 'zod'
import { validateWithZodSchema } from '../../core/utils/utilities.ts'

export const DealOriginationExclusionRowSchema = z
  .object({
    deal_type_id: z.string(),
    deal_type__label: z.string().nullish(),
    pipeline_deal_type_exclusions__id: z.string().nullish(),
    excluded: z.boolean(),
    origination_deals_count: z.number().nullish()
  })
  .strict()

export type DealOriginationExclusionRow = z.infer<typeof DealOriginationExclusionRowSchema>

export function validateDealOriginationExclusionRow(
  data: unknown,
  options?: { isArray?: boolean }
): DealOriginationExclusionRow | DealOriginationExclusionRow[] {
  try {
    return validateWithZodSchema(
      DealOriginationExclusionRowSchema,
      data,
      'deal origination exclusion row',
      options
    ) as DealOriginationExclusionRow | DealOriginationExclusionRow[]
  } catch (e) {
    throw new Error(`Deal origination exclusion validation failed: ${e}`)
  }
}
